import { makeDictionary } from "src/common/makeDictionary";
import { BusinessServiceDescriptor } from "./BusinessServiseDescriptor";
import { bsRegistration } from "./services/bsRegistration";
import { bsBom2 } from "./services/bsBom2";
import { bsBom2a } from "./services/bsBom2a";
import { bsBom3 } from "./services/bsBom3";
import { bsChat } from "./services/bsChat/bsChat";
import { bsMeasurementChart } from "./services/bsMeasurementChart/bsMeasurementChart";
import { bsMeasurementChart2 } from "./services/bsMeasurementChart2";
import { bsCareLabel, bsTechpack } from "./services/bsTechpack";
import { bsScheduling } from "./services/bsScheduling";
import { bsPlanning2 } from "./services/bsPlanning2";
import { bsSample } from "./services/bsSample";
import { bsAssortmentTable } from "./services/bsAssortmentTable";
import { bsSample2 } from "./services/bsSample2";

export const allBusinessServices: BusinessServiceDescriptor[] = [
  bsBom2,
  bsBom2a,
  bsBom3,
  bsRegistration,
  bsChat,
  bsMeasurementChart,
  bsMeasurementChart2,
  bsTechpack,
  bsCareLabel,
  bsScheduling,
  bsPlanning2,
  bsSample,
  bsSample2,
  bsAssortmentTable,
];

export const businessServicesDict = makeDictionary(
  allBusinessServices,
  ({ key }) => key,
);
